import React from 'react';
import ReactDOM from 'react-dom';
//import Autocomplete from 'react-autocomplete';
import Api from '../../Shared/Api';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import './DealerAutocomplete.scss';

export default class DealerAutocomplete extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            value: '',
            selectedItem: null,
            data: [],
            address: ''
        }

        this.navigateToDealer = this.navigateToDealer.bind(this);
        this.onSelectItem = this.onSelectItem.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    handleFormSubmit(event) {

        event.preventDefault();

        geocodeByAddress(this.state.address)
            .then(results => getLatLng(results[0]))
            .then(latLng => console.log('Success', latLng))
            .catch(error => console.error('Error', error));
          this.navigateToDealer(this.state.address);
    }

    onChange(e) {
        this.setState({ address:  e })
    }

    navigateToDealer(item) {
        window.location = '/Dealer-Locator' + (item ? `?dealer=${item}` : '');
    }

    submitSelectedDealer(e) {
        e.preventDefault();
        this.navigateToDealer(this.state.selectedItem);
    }

    render() {
        const options = {
            types: ['(regions)'],
            componentRestrictions: { country: "us" }
        }
        const inputProps = {
            value: this.state.address,
            onChange: this.onChange,
        }
        return (
            <div className="dealer-autocomplete">
                <h3>Find your local aamco</h3>
                <form className="input-wrapper" onSubmit={(e) => this.handleFormSubmit(e)}>
                    <PlacesAutocomplete
                        options={options}
                        inputProps={inputProps}
                        googleLogo={false}
                        getItemValue={(item) => item.fullAddress}
                        renderItem={(item, isHighlighted) =>
                            <div key={item.id} className="menu-item" style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                                <img src="./images/location-small.svg" alt="location-small" />
                                {item.fullAddress}
                            </div>
                        }
                        shouldItemRender={(item, value) => (item.fullAddress ? item.fullAddress.toLowerCase().indexOf(value.toLowerCase()) : -1) > -1}
                        menuStyle={{
                            borderRadius: '0',
                            position: 'fixed',
                            maxHeight: '250px',
                            maxWidth: '200px',
                            overflow: 'auto',
                            position: 'absolute',
                            top: 'initial',
                            left: 'initial'
                        }}
                        value={this.state.value}
                        onSelect={this.onSelectItem}
                    />
                    <input type="submit" className="btn-go btn-transparent" value="GO" />
                </form>
                <a onClick={(e) => this.navigateToDealer()} className="dealer-link" href="#">See All Locations</a>
            </div>
        );
    }

    onSelectItem(value, item) {

        this.setState({ value, selectedItem: this.state.address });
        this.navigateToDealer(value);
    }

    loadData() {
        Api.getDealers().then(res => {
            this.setState({ data: res });
        });
    }
}

ReactDOM.render(<DealerAutocomplete />, document.getElementById('dealerAutocomplete'));


// WEBPACK FOOTER //
// ./Src/Home/DealerAutocomplete/DealerAutocomplete.jsx